export default __webpack_public_path__ + "56ce8e9cbf30a8f737e3556d0c544316.wasm";